import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import de from 'assets/locales/de.json';
import en from 'assets/locales/en.json';

export const resources = {
  en: {
    translation: en,
  },
  de: {
    translation: de,
  },
};

export const defaultNS = 'translation';

const initializei18n = async () => {
  try {
    await i18next.use(initReactI18next).init({
      resources,
      defaultNS,
      lng: 'en',
      fallbackLng: 'en',
      interpolation: {
        escapeValue: false,
      },
    });
  } catch (error) {
    // i18n fails before the error service can use translations — use console as fallback
    console.error('Failed to initialize i18n:', error);
  }
};

initializei18n();
